const canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

export const getUrl = () => {
  if (canUseDOM) {
    const protocol = window.location.protocol;
    const domain = window.location.hostname;
    const port = window.location.port;

    return `${protocol}//${domain}${port ? `:${port}` : ''}`;
  }

  if (process.env.DOMAIN) {
    return process.env.DOMAIN;
  }

  if (process.env.RAILWAY_PUBLIC_DOMAIN) {
    return 'https://' + process.env.RAILWAY_PUBLIC_DOMAIN;
  }

  return 'http://localhost:3000';
};

export const getUrlOrDebug = () => {
  if (process.env.NEXT_PUBLIC_DEBUG_ENV) {
    return process.env.NEXT_PUBLIC_DEBUG_ENV;
  }

  return getUrl();
};
